module.exports = __webpack_public_path__ + "static/media/combat(25).251aaf15.PNG";